import {
  FlowConsumerOfPatientOrderSchema,
  FlowCreateNotableObjectConfigSchema,
  FlowNotableObject,
} from 'flow-schema';
import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BaseNotableObjectConfigSchema,
  BlockType,
} from '../base/baseSchema.js';

export const CreateEncounterConfigSchema = BaseNotableObjectConfigSchema.extend({
  notableObject: z.literal(FlowNotableObject.Encounter),
  payload: z.string(),
});

export const CreatePatientConfigSchema = BaseNotableObjectConfigSchema.extend({
  notableObject: z.literal(FlowNotableObject.Patient),
  payload: z.string(),
});

export const CreateServiceReviewSubmissionsConfigSchema = BaseNotableObjectConfigSchema.extend({
  notableObject: z.literal(FlowNotableObject.ServiceReviewSubmissions),
  payload: z.string(),
  order: FlowConsumerOfPatientOrderSchema({ isRequired: true }),
});

export const CreateAuthorizationSubmissionsConfigSchema = BaseNotableObjectConfigSchema.extend({
  notableObject: z.literal(FlowNotableObject.AuthorizationSubmissions),
  payload: z.string(),
  order: FlowConsumerOfPatientOrderSchema({ isRequired: true }),
});

export const CreateNotableObjectBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.CreateNotableObject),
  config: FlowCreateNotableObjectConfigSchema,
});

export type CreateNotableObjectBlock = z.infer<typeof CreateNotableObjectBlockSchema>;
